<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      $_reload: this.$_reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    $_reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
 #app {
   height: 100%;
   width: 100%;
 }
@import './style/index.scss';
@import url('//at.alicdn.com/t/font_1360242_1iaxkg3egoxi.css');
// @import './style/iconfont/iconfont.css';
</style>



// WEBPACK FOOTER //
// src/App.vue